import { ReactNode } from 'react';

import { useMediaQuery } from '@providers/MediaQueryProvider';
import { SlimArrowButton } from '@ui/components/SlimArrowButton';

import { ExternalAuthButton } from '@features/auth/ui/ExternalAuthButton/ExternalAuthButton';
import { SiteLayout } from '@features/shared/ui/SiteLayout';

import styles from './PlayerProfilePage.module.css';

type Props = {
  shieldAvatar: ReactNode;
  eloStats: ReactNode;
  subscriptions?: ReactNode;
  achievements: ReactNode;
  clubsAndTournaments: ReactNode;
  actions: ReactNode;
  themeColor?: string | null;
  onBack: () => void;
  modals: ReactNode;
  chessRussianProfileLink: string;
};
export function PlayerProfilePage({
  actions,
  shieldAvatar,
  eloStats,
  subscriptions,
  achievements,
  clubsAndTournaments,
  themeColor,
  onBack,
  modals,
  chessRussianProfileLink,
}: Props) {
  const isMobile = useMediaQuery() === 'mobile';

  const goToChessRussianProfile = () => window.open(chessRussianProfileLink, '_blank', 'noopener');

  return (
    <SiteLayout
      className={styles.layout}
      themeColor={themeColor}
      siteLogo={
        <div className={styles.siteLogoContainer}>
          <SlimArrowButton
            size={isMobile ? '28' : '32'}
            direction="left"
            onClick={onBack}
            colorPreset="currentColor"
          />
          {!isMobile && <div className={styles.pageTitle}>Личный кабинет</div>}
        </div>
      }
      centeredTitle={isMobile ? <div className={styles.pageTitle}>Личный кабинет</div> : undefined}
      actions={actions}
      backgroundPreset="plain"
    >
      <div className={styles.content}>
        <div className={styles.rightColumn}>
          {shieldAvatar}

          <ExternalAuthButton
            className={styles.chessRussianProfileButton}
            provider="chessopenProfile"
            onClick={goToChessRussianProfile}
          />
        </div>
        <div className={styles.mainContent}>
          {eloStats}

          {subscriptions}

          {achievements}

          {clubsAndTournaments}
        </div>
      </div>

      {modals}
    </SiteLayout>
  );
}
